import axios from "axios";
import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";

// Clean instance for CLIENT-authenticated portal calls, same pattern as
// useClientAppointments: the shared apiClient overwrites Authorization with
// the widget's public-session token (the backend would 401 "Client
// authentication required") and its interceptor turns any 401 into the
// fullscreen session-expired overlay.
const clientApi = axios.create();

export type WaitlistJoinPayload = {
  client_name: string;
  client_phone: string;
  client_email?: string;
  service_id: number;
  staff_id?: number | null;
  date_from: string;
  date_to: string;
  time_pref: "any" | "morning" | "afternoon" | "evening";
};

export type WaitlistClaimResponse = {
  status: string;
  entry: {
    id: number; status: string; service_id: number; service_title?: string;
    staff_id: number | null; staff_name?: string | null;
    client_name: string; client_phone: string; client_email?: string | null;
    date_from: string; date_to: string; time_pref: string;
  };
  offered_slot: { staff_id: number; date: string; start: string } | null;
  claim_window_hours: number;
};

export async function joinWaitlist(payload: WaitlistJoinPayload) {
  const { data } = await apiClient.post(apiPath("/waitlist/join"), payload);
  return data;
}

export async function resolveClaim(token: string): Promise<WaitlistClaimResponse> {
  const { data } = await apiClient.get(apiPath(`/waitlist/claim/${token}`));
  return data;
}

export async function cancelWaitlistEntry(token: string) {
  const { data } = await apiClient.post(apiPath(`/waitlist/claim/${token}/cancel`), {});
  return data;
}

/** Portal-only: /waitlist/mine is require_client on the backend — it needs
 *  the logged-in client's access token, NOT the public session. */
export async function fetchMyWaitlist(accessToken: string) {
  const baseURL = apiClient.defaults.baseURL || "";
  const { data } = await clientApi.get(baseURL + apiPath("/waitlist/mine"), {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return data;
}
